var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-button-icon",class:[
		("ci-button-icon--" + _vm.theme),
		("ci-button-icon--" + _vm.size) ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"ci-button-icon__icon",class:[
			_vm.name
		]})])}
var staticRenderFns = []

export { render, staticRenderFns }